<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="true"
      autocomplete="off"
    >
      <v-card>
        <v-card-title>
          <span class="headline font-weight-bold">Modifica Riparazione</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Ricerca Smartphone"
                  v-model="model"
                  :search-input.sync="search"
                  :items="smartphones"
                  :loading="isLoading"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  return-object
                  :rules="[rules.required]"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.cost"
                  label="Costo"
                  type="number"
                  readonly
                  disabled
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.price"
                  label="Prezzo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-text>
          <v-col>
            <v-row>
              <v-col>
                <h1 class="primary--text">Pezzi di Ricambio</h1>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete
                  label="Cerca"
                  v-model="replacementModel"
                  :search-input.sync="replacementSearch"
                  :items="filteredReplacements"
                  :loading="isLoading"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="2"
                lg="1"
                class="pt-8"
              >
                <v-btn
                  small
                  color="primary"
                  @click="add('replacement')"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-list>
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="(item, index) in editedItem.replacements"
                      :key="index"
                    >
                      <v-list-item-icon>
                        <v-icon
                          color="red"
                          @click="remove('replacement', index)"
                        >mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{item.name}} {{item.model}} {{item.state}} {{item.color || ''}} | {{item.supplier.name}} {{item.cost}}€</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>

        <v-card-text>
          <v-col>
            <v-row>
              <v-col>
                <h1 class="primary--text">Accessori Mancanti</h1>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete
                  label="Cerca"
                  v-model="accessoryModel"
                  :search-input.sync="accessorySearch"
                  :items="filteredAccessories"
                  :loading="isLoading"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="2"
                lg="1"
                class="pt-8"
              >
                <v-btn
                  small
                  color="primary"
                  @click="add('accessory')"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-list>
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="(item, index) in editedItem.batches"
                      :key="index"
                    >
                      <v-list-item-icon>
                        <v-icon
                          color="red"
                          @click="remove('accessory', index)"
                        >mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{item.accessory.serial_code}} {{item.accessory.brand}} {{item.accessory.model}} {{item.accessory.color || ''}} {{item.accessory.description || ''}} | {{item.cost}} -> {{item.accessory.price}}€ {{item.supplier.name}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >Cancella</v-btn>
          <v-btn
            color="primary"
            text
            @click="save"
          >Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'EditForm',
    data() {
      return {
        search: null,
        replacementSearch: null,
        accessorySearch: null,
        model: null,
        replacementModel: null,
        accessoryModel: null,
        smartphones: [],
        replacements: [],
        accessories: [],
        replacementSearchItems: [],
        accessorySearchItems: [],
        isLoading: false,
        valid: false,
        editedItem: {},
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },

    props:
    {
      item: { type: Object }
    },

    computed: {
      ...mapGetters([
        'getRiparazioniBytewoodEdit'
      ]),
      dialog: {
        get() {
          return this.getRiparazioniBytewoodEdit
        },
        set() {
          this.CHANGE_RIPARAZIONI_BYTEWOOD_EDIT(false)
        }
      },
      filteredReplacements() {
        return this.replacements.filter(el => el.amount > 0)
      },
      filteredAccessories() {
        return this.accessories.filter(el => el.amount > 0)
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_BYTEWOOD_EDIT'
      ]),

      async fetchSmartphones() {

        const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/repairs/bytewood/fetch-to-edit`, { serial_number: this.item.serial_number }, this.config)

        this.smartphones = data.map(el => {

          el.text = `[${el.supplier.name}] ${el.serial_number} ${el.ean || ''} ${el.smartphone.brand} ${el.smartphone.model} ${el.smartphone.color}, ${el.smartphone.disk_space} / ${el.smartphone.ram} ${el.desctiption || ''}`

          return el
        })
      },

      async fetchReplacements() {

        const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/replacements/fetch`, this.config)

        this.replacements = data.map(el => {
          el.text = `${el.amount}x ${el.name} ${el.model} ${el.state} ${el.color || ''} | ${el.supplier.name} ${el.cost}€`
          return el
        })
      },

      async fetchAccessories() {

        const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/accessories/fetch`, this.config)

        this.accessories = data.map(el => {
          if (!el.accessory) return null // sono presenti discrepanze nel db
          el.text = `${el.amount}x ${el.accessory.serial_code} ${el.accessory.brand} ${el.accessory.model} ${el.accessory.color || ''} ${el.accessory.description || ''} | ${el.cost}€ -> ${el.accessory.price}€ ${el.supplier.name}`
          return el
        }).filter(el => el != null)
      },

      add(kind) {
        if (kind == 'replacement') {
          this.editedItem.replacements.push(this.replacementModel)

          this.replacements = this.replacements.map(el => {
            if (el.id == this.replacementModel.id) {
              el.amount--
            }

            return el
          })

          this.replacementModel = null

        } else if (kind = 'accessory') {
          this.editedItem.batches.push(this.accessoryModel)

          this.accessories = this.accessories.map(el => {
            if (el.id == this.accessoryModel.id) {
              el.amount--
            }

            return el
          })

          this.accessoryModel = null
        }
      },

      remove(kind, index) {
        if (kind == 'replacement') {

          this.replacements = this.replacements.map(el => {
            if (el.id == this.editedItem.replacements[index].id) {
              el.amount++
            }

            return el
          })

          this.editedItem.replacements.splice(index, 1);

        } else if (kind = 'accessory') {

          this.accessories = this.accessories.map(el => {
            if (el.id == this.editedItem.batches[index].id) {
              el.amount++
            }

            return el
          })

          this.editedItem.batches.splice(index, 1);
        }
      },

      close() {
        this.CHANGE_RIPARAZIONI_BYTEWOOD_EDIT(false)
      },

      async save() {
        if (this.$refs.form.validate()) {

          this.$emit('edit-submit', 'reset')

          const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/repairs/bytewood/update`, { payload: this.editedItem }, this.config)

          if (data.status) {

            this.$emit('edit-submit', 'ok')
            this.close()
          } else {

            this.$emit('edit-submit', 'error')
          }

        }
      },
    },

    watch: {
      dialog(val) {
        val || this.close() && this.CHANGE_RIPARAZIONI_BYTEWOOD_EDIT(false)
      },

      async item(val) {

        this.fetchSmartphones()
          .then(() => {
            this.smartphones.map(el => {
              if (el.serial_number == val.serial_number) {
                this.model = el
                this.editedItem = el
              }
            })
          })

        await this.fetchReplacements()
        await this.fetchAccessories()
      },

      model(val) {
        if (val) {
          this.editedItem = val
        }
      },
    },
  }
</script>

<style>
</style>